"use client";

import { c as _c } from "react/compiler-runtime";
import SocialStatementIcon from "@/components/user/utils/icons/SocialStatementIcon";
import CopyIcon from "@/components/utils/icons/CopyIcon";
import OutsideLinkIcon from "@/components/utils/icons/OutsideLinkIcon";
import type { CicStatement } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { TOOLTIP_STYLES } from "@/helpers/tooltip.helpers";
import { STATEMENT_META } from "@/helpers/Types";
import { useEffect, useState } from "react";
import { Tooltip } from "react-tooltip";
import { useCopyToClipboard } from "react-use";
import UserPageIdentityDeleteStatementButton from "./UserPageIdentityDeleteStatementButton";
export default function UserPageIdentityStatementsStatement(t0) {
  const $ = _c(45);
  const {
    statement,
    profile,
    canEdit
  } = t0;
  const [title, setTitle] = useState(statement.statement_value);
  const [, copyToClipboard] = useCopyToClipboard();
  let t1;
  if ($[0] !== copyToClipboard || $[1] !== statement.statement_value || $[2] !== title) {
    t1 = () => {
      copyToClipboard(title);
      setTitle("Copied!");
      setTimeout(() => {
        setTitle(statement.statement_value);
      }, 1000);
    };
    $[0] = copyToClipboard;
    $[1] = statement.statement_value;
    $[2] = title;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleCopy = t1;
  const canOpen = STATEMENT_META[statement.statement_type].canOpenStatement;
  const [isTouchScreen, setIsTouchScreen] = useState(false);
  let t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setIsTouchScreen(window.matchMedia("(pointer: coarse)").matches);
    };
    t3 = [];
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== statement.statement_type) {
    t4 = <div className="tw-flex-shrink-0 tw-w-5 tw-h-5 tw-flex tw-items-center tw-justify-center"><SocialStatementIcon statementType={statement.statement_type} /></div>;
    $[6] = statement.statement_type;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = STATEMENT_META[statement.statement_type];
  let t6;
  if ($[8] !== t5.title) {
    t6 = <div className="tw-text-xs tw-font-semibold tw-text-iron-500 tw-leading-none">{t5.title}</div>;
    $[8] = t5.title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== statement.statement_value || $[11] !== title) {
    t7 = title === "Copied!" ? <span className="tw-text-primary-400">{title}</span> : statement.statement_value;
    $[10] = statement.statement_value;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t7) {
    t8 = <div className="tw-text-xs tw-font-medium tw-text-iron-100 tw-break-all tw-leading-4 tw-mt-1.5">{t7}</div>;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div className="tw-min-w-0">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t4 || $[19] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-3.5 tw-min-w-0">{t4}{t9}</div>;
    $[18] = t4;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== canOpen || $[22] !== isTouchScreen || $[23] !== statement.id || $[24] !== statement.statement_value) {
    t11 = canOpen && <><a href={statement.statement_value} target="_blank" rel="noopener noreferrer" className="tw-border-none tw-bg-transparent tw-p-1.5 lg:tw-p-0 tw-cursor-pointer tw-text-iron-600 hover:tw-text-iron-200 focus:tw-outline-none tw-transition tw-duration-300 tw-ease-out" data-tooltip-id={`open-statement-${statement.id}`}><div className="tw-h-5 tw-w-5 lg:tw-h-4 lg:tw-w-4 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 [&>svg]:tw-w-full [&>svg]:tw-h-full"><OutsideLinkIcon /></div></a>{!isTouchScreen && <Tooltip id={`open-statement-${statement.id}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES}><span className="tw-text-xs">Open</span></Tooltip>}</>;
    $[21] = canOpen;
    $[22] = isTouchScreen;
    $[23] = statement.id;
    $[24] = statement.statement_value;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = `copy-statement-${statement.id}`;
  let t13;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="tw-h-5 tw-w-5 lg:tw-h-4 lg:tw-w-4 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 [&>svg]:tw-w-full [&>svg]:tw-h-full"><CopyIcon /></div>;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== handleCopy || $[28] !== t12) {
    t14 = <button aria-label="Copy" className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-1.5 lg:tw-p-0 tw-text-iron-600 tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-200 focus:tw-outline-none" onClick={handleCopy} data-tooltip-id={t12}>{t13}</button>;
    $[27] = handleCopy;
    $[28] = t12;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== isTouchScreen || $[31] !== statement.id) {
    t15 = !isTouchScreen && <Tooltip id={`copy-statement-${statement.id}`} place="top" positionStrategy="fixed" offset={8} opacity={1} style={TOOLTIP_STYLES}><span className="tw-text-xs">Copy</span></Tooltip>;
    $[30] = isTouchScreen;
    $[31] = statement.id;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== canEdit || $[34] !== profile || $[35] !== statement) {
    t16 = canEdit && <UserPageIdentityDeleteStatementButton statement={statement} profile={profile} />;
    $[33] = canEdit;
    $[34] = profile;
    $[35] = statement;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t11 || $[38] !== t14 || $[39] !== t15 || $[40] !== t16) {
    t17 = <div className="tw-flex tw-items-center tw-gap-3 lg:tw-gap-2 tw-ml-3 tw-flex-shrink-0 tw-leading-none">{t11}{t14}{t15}{t16}</div>;
    $[37] = t11;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t10 || $[43] !== t17) {
    t18 = <li className="tw-group hover:tw-bg-white/[0.02] tw-pl-0.5 tw-py-4 tw-transition-colors tw-duration-200 tw-ease-out tw-border-b tw-border-solid tw-border-white/[0.06] tw-border-t-0 tw-border-x-0 last:tw-border-b-0"><div className="tw-flex tw-items-center tw-justify-between tw-gap-3">{t10}{t17}</div></li>;
    $[42] = t10;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
}